import xeroLogo from '../../assets/images/xero.png';
import quickbooksLogo from '../../assets/images/quickbook.png';
import sageLogo from '../../assets/images/sage.png';
import businessCentralLogo from '../../assets/images/businesscentral.svg';

export interface IAccountingProvider {
  code: string;
  name: string;
  logo: string;
}

/**
 * The accounting ledgers the app connects to, named as the integrations page names them, with
 * the logo each tile shows. One list for the review's Integration column and filter, the Chart
 * of Accounts page and the connector pages, so a provider is spelt one way everywhere.
 */
export const ACCOUNTING_PROVIDERS: IAccountingProvider[] = [
  { code: 'xero', name: 'Xero', logo: xeroLogo },
  { code: 'quickbooks', name: 'QuickBooks', logo: quickbooksLogo },
  { code: 'sage', name: 'Sage Accounting', logo: sageLogo },
  { code: 'sage200', name: 'Sage 200 Standard', logo: sageLogo },
  { code: 'businesscentral', name: 'Dynamics 365 Business Central', logo: businessCentralLogo },
];

export const accountingProvider = (code?: string | null): IAccountingProvider | undefined =>
  ACCOUNTING_PROVIDERS.find(provider => provider.code === code);

/** The provider's display name, or the code itself for one this list does not know. */
export const accountingProviderName = (code?: string | null): string =>
  accountingProvider(code)?.name || code || '';
